/* Card Imports theme JS — menu drawer, cart drawer, AJAX add-to-cart, qty +/-, remove */
(function () {
  'use strict';
  /* Menu drawer */
  var menuToggles = document.querySelectorAll('.menu-btn, .header-menu-toggle, [aria-controls="MenuDrawer"]');
  var menuDrawer = document.getElementById('MenuDrawer');
  var menuBackdrop = document.querySelector('[data-menu-backdrop]');
  var menuCloser = document.querySelector('[data-close-menu]');
  function setMenuExpanded(open) { menuToggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); }); }
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.setAttribute('aria-hidden', 'false');
    menuDrawer.setAttribute('data-open', 'true');
    setMenuExpanded(true);
    if (menuBackdrop) menuBackdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.setAttribute('aria-hidden', 'true');
    menuDrawer.removeAttribute('data-open');
    setMenuExpanded(false);
    if (menuBackdrop) menuBackdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  menuToggles.forEach(function (t) { t.addEventListener('click', openMenu); });
  if (menuCloser) menuCloser.addEventListener('click', closeMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);
  if (menuDrawer) menuDrawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });

  /* Cart drawer */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartBackdrop = document.querySelector('[data-cart-backdrop]');
  var cartCloser = document.querySelector('[data-close-cart]');
  var cartItems = document.querySelector('[data-cart-items]');
  var cartEmpty = document.querySelector('[data-cart-empty]');
  var cartFoot = document.querySelector('[data-cart-foot]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');
  var itemTemplate = document.getElementById('CartItemTemplate');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.setAttribute('data-open', 'true');
    if (cartBackdrop) cartBackdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.removeAttribute('data-open');
    if (cartBackdrop) cartBackdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function updateCartBadges(count) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; }); }
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeCart(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }
  function renderCart(cart) {
    if (!cartItems || !itemTemplate) return;
    cartItems.innerHTML = '';
    if (!cart || cart.item_count === 0) {
      if (cartEmpty) cartEmpty.hidden = false;
      if (cartFoot) cartFoot.hidden = true;
      updateCartBadges(0);
      return;
    }
    if (cartEmpty) cartEmpty.hidden = true;
    if (cartFoot) cartFoot.hidden = false;
    cart.items.forEach(function (item) {
      var node = itemTemplate.content.cloneNode(true);
      var li = node.querySelector('li');
      li.dataset.key = item.key;
      var img = node.querySelector('[data-item-img]');
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_128x128$1');
          img.alt = item.title;
        } else { img.style.display = 'none'; }
      }
      var link = node.querySelector('[data-item-link]');
      if (link) link.href = item.url;
      var title = node.querySelector('[data-item-title]');
      if (title) { title.textContent = item.product_title; title.href = item.url; }
      var variant = node.querySelector('[data-item-variant]');
      if (variant) {
        if (item.variant_title && item.variant_title !== 'Default Title') variant.textContent = item.variant_title;
        else variant.style.display = 'none';
      }
      var qty = node.querySelector('[data-item-qty]');
      if (qty) qty.textContent = item.quantity;
      var price = node.querySelector('[data-item-price]');
      if (price) price.textContent = formatMoney(item.final_line_price);
      cartItems.appendChild(node);
    });
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    updateCartBadges(cart.item_count);
  }

  /* AJAX add-to-cart for any form pointing at /cart/add */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var originalLabel = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.dataset.busy = 'true'; button.innerHTML = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart'); }); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart); openCart();
        if (button && originalLabel) {
          button.innerHTML = 'Added ✓';
          setTimeout(function () { button.innerHTML = originalLabel; button.disabled = false; delete button.dataset.busy; }, 1200);
        }
      })
      .catch(function (err) {
        if (button) {
          button.innerHTML = err && err.message ? String(err.message).slice(0, 24) : 'Try again';
          setTimeout(function () { button.innerHTML = originalLabel; button.disabled = false; delete button.dataset.busy; }, 2200);
        }
      });
  });

  /* Header cart pill opens drawer */
  document.querySelectorAll('[data-open-cart], .nav-cart').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      fetchCart().then(function (cart) { renderCart(cart); openCart(); });
    });
  });
  if (cartCloser) cartCloser.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartDrawer && cartDrawer.getAttribute('data-open') === 'true') closeCart();
      else closeMenu();
    }
  });
  if (cartItems) {
    cartItems.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-up], [data-qty-down], [data-item-remove]');
      if (!btn) return;
      var li = btn.closest('li'); if (!li) return;
      var key = li.dataset.key;
      var qtyEl = li.querySelector('[data-item-qty]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var next = current;
      if (btn.hasAttribute('data-qty-up')) next = current + 1;
      else if (btn.hasAttribute('data-qty-down')) next = Math.max(0, current - 1);
      else if (btn.hasAttribute('data-item-remove')) next = 0;
      btn.disabled = true;
      changeCart(key, next).then(function (cart) { renderCart(cart); btn.disabled = false; });
    });
  }

  fetchCart().then(function (cart) { updateCartBadges(cart.item_count); }).catch(function () {});

  /* Countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) { el.textContent = '00:00:00'; return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  });
  document.querySelectorAll('select[name="address[country]"]').forEach(function (sel) {
    if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
      try { new Shopify.CountryProvinceSelector(sel.id || 'AddressCountry', 'AddressProvince', { hideElement: 'AddressProvinceContainer' }); } catch (e) {}
    }
  });
})();
